import React from "react";
import { ConvertAmount } from "../../../components/Comman/ConvertValueWithDenominator";
import { MONTH_COLUMNS } from "../constants/stockHolderTargetConstants";
import tableStyles from "../styles/tableStyles";

/**
 * BeatTargetRow
 *
 * A single row in the beat-target table.
 * Wrapped in React.memo so it only re-renders when its own `row` data changes,
 * preventing the entire visible page from re-painting on every keystroke.
 *
 * Props:
 *  - row                  {object}   Full beat-target data object for this row
 *  - onTextFieldDataChange {Function} Curried handler: (monthName, beatId) => (event) => void
 */
const BeatTargetRow = React.memo(({ row, onTextFieldDataChange }) => (
    <tr>
        <td style={tableStyles.tdCenter}>{row.index}</td>
        <td style={tableStyles.td}>{row.regionName}</td>
        <td style={tableStyles.td}>{row.stateName}</td>
        <td style={tableStyles.td}>{row.zoneName}</td>
        <td style={tableStyles.td}>{row.areaName}</td>
        <td style={tableStyles.td}>{row.beatName}</td>

        {MONTH_COLUMNS.map(({ name }) => (
            <td key={name} style={tableStyles.td}>
                <input
                    className="customTextfield"
                    placeholder="Target"
                    value={row[name] ?? ""}
                    onChange={(e) => {
                        const val = e.target.value;
                        if (!val || /^\d*\.?\d*$/.test(val)) {
                            onTextFieldDataChange(name, row.id)(e);
                        }
                    }}
                    inputMode="decimal"
                    style={tableStyles.input}
                />
            </td>
        ))}

        <td style={tableStyles.tdRight}>
            {row.totalTarget !== null
                ? ConvertAmount({ amount: row.totalTarget })
                : 0}
        </td>
    </tr>
));

BeatTargetRow.displayName = "BeatTargetRow";

export default BeatTargetRow;